/* skull.icon.svg.js */

"use strict";
module.exports = {
    icon: `
            <svg viewBox="0 0 24 24" preserveAspectRatio="none">
                <path class="foreground-gl" d="M12,0C6,0,1.2,4.8,1.2,10.8c0,3.6,1.8,7,4.8,9V24h2.4v-3.6h2.4V24h2.4v-3.6h2.4V24H18v-4.2c3-2,4.8-5.4,4.8-9 C22.8,4.8,18,0,12,0 M7.2,10.8c1.3,0,2.4,1.1,2.4,2.4s-1.1,2.4-2.4,2.4s-2.4-1.1-2.4-2.4S5.9,10.8,7.2,10.8 M16.8,10.8 c1.3,0,2.4,1.1,2.4,2.4s-1.1,2.4-2.4,2.4c-1.3,0-2.4-1.1-2.4-2.4S15.5,10.8,16.8,10.8 M12,14.4l1.8,3.6h-3.6L12,14.4z"/> 
            </svg>
        `,
};
